module.exports = __webpack_public_path__ + "static/img/jt1.a20397d1.png";